import { Injectable } from "@angular/core"
import { AngularFireAuth } from "@angular/fire/auth"
import { AngularFirestore } from "@angular/fire/firestore"

import { showNotification } from "@tr/utils"
import { DataService } from "./data.service"

declare var $: any

@Injectable({
  providedIn: "root",
})
export class PaymentsService {
  public userId: string

  public get company(): string { return this.dataService.company.value }
  public set company(company: string) { this.dataService.company.next(company) }
  public get uid(): string { return this.dataService.uid.value }
  public set uid(uid: string) { this.dataService.uid.next(uid) }

  constructor(private dataService: DataService, private db: AngularFirestore, private afAuth: AngularFireAuth) {
    this.afAuth.authState.subscribe(auth => {
      if (auth) {
        this.userId = auth.uid
      }
    })
  }

  public async processPayment(
    token: { id?: string, customerId?: string, email: string },
    amount: number,
    credits: number,
    creditPrice: number,
    discountUsed: string,
  ): Promise<void> {
    if (Math.round(credits) !== credits) {
      credits = Math.round(credits)
      amount = credits * creditPrice * 100
    }
    amount = Math.round(amount * 100) / 100
    const dollarAmount = amount / 100
    const message = "Your payment of $" + dollarAmount + " for " + credits +
     " credits is being processed and will be added to your account shortly."
    showNotification(message)

    const payment = {
      token,
      amount,
      credits,
      uid: this.uid,
      company: this.company,
      discountUsed,
    }
    const tempID = new Date() + " Amount: " + amount

    return this.db
      .collection("companies")
      .doc(this.company)
      .collection("transactions")
      .doc(tempID)
      .set(payment)
      .catch(error => {
        showNotification(`There was an error with your payment: ${error} Please try again later or contact Support`, "warning")
      })
  }
}
